import { Typography, Container } from "@mui/material";

const PrivacyPolicy = () => {
    return (
        <Container sx={{ margin: "30px auto" }}>
            <Typography component="h1" variant="h4" align="center" mb={4}>
                Privacy Policy
            </Typography>

            <Typography mb={2}>Disclaimer – JHARE EXPRESS, LLC</Typography>

            <Typography mb={2}>
                These terms of service apply to all shipments processed by or
                through Jhare Express LLC.
            </Typography>

            <Typography mb={2}>
                While we are committed to providing reliable, efficient, and
                timely shipping services, there are external factors beyond our
                control that may affect delivery timelines. Jhare Express LLC is
                not an airline carrier, and as such, we are not liable for
                delays, loss, or damage caused by airline mishandling, customs
                inspections, weather events, or any other force majeure
                circumstances.
            </Typography>

            <Typography mb={2}>
                We strongly recommend that all shipments be insured—either
                through Jhare Express LLC or through another valid insurance
                provider—to protect against potential loss, damage, or theft. In
                the event of damage or loss during air transport, while Jhare
                Express LLC is not liable, we will assist customers in good
                faith with filing claims with the responsible airline carrier.
            </Typography>

            <Typography mb={2}>
                All applicable port charges, transportation costs, U.S. and
                Nigerian customs duties, TSA/HLS inspection fees, CES Exodus
                examination charges, and any other regulatory or processing fees
                are the sole responsibility of the customer.
            </Typography>

            <Typography mb={2}>
                Customers must ensure that no hazardous materials, firearms,
                stolen property, or contraband are included in any shipment. By
                shipping with Jhare Express LLC, customers grant U.S. and
                Nigerian customs authorities, TSA agents, and authorized
                representatives of Jhare Express LLC permission to open and
                inspect shipments as required by law.
            </Typography>

            <Typography mb={2}>
                Any additional fees related to customs clearance, inspection,
                demurrage, or storage must be paid by the specified deadline.
                Failure to make timely payment may result in late fees, storage
                charges, or forfeiture of the shipment. If a shipment remains
                unclaimed or unpaid for more than 30 days from the arrival date,
                Jhare Express LLC reserves the right to dispose of or sell the
                shipment contents to recover outstanding costs.
            </Typography>

            <Typography mb={2}>
                Estimated delivery dates are subject to change and are not
                guaranteed. Delays may occur due to customs processing, carrier
                schedules, or other factors beyond our control.
            </Typography>

            <Typography mb={2}>
                By using our services, customers agree to indemnify and hold
                Jhare Express LLC harmless from any and all claims, damages, or
                liabilities—whether valid or not—that may arise in connection
                with the shipment. Customers also agree to bear responsibility
                for any legal fees incurred by Jhare Express LLC in the event of
                a dispute or legal action.
            </Typography>
        </Container>
    );
};

export default PrivacyPolicy;
